import { auth } from "./auth";
import { avatar } from "./avatar";
import { banner } from "./banner";
import { board } from "./board";
import { bookmarkList } from "./bookmarkList";
import { call } from "./call";
import { callError } from "./callError";
import { chat } from "./chat";
import { common } from "./common";
import { contact } from "./contact";
import { dailyBonus } from "./dailyBonus";
import { discover } from "./discover";
import { editProfile } from "./editProfile";
import { fleamarket } from "./fleamarket";
import { footprint } from "./footprint";
import { gallery } from "./gallery";
import { gift } from "./gift";
import { insufficientPointSheet } from "./insufficientPointSheet";
import { landing } from "./landing";
import { launchCampaign } from "./launchCampaign";
import { likeList } from "./likeList";
import { live } from "./live";
import { lovenseLp } from "./lovenseLp";
import { media } from "./media";
import { messages } from "./messages";
import { moderation } from "./moderation";
import { myProfile } from "./myProfile";
import { nav } from "./nav";
import { news } from "./news";
import { notification } from "./notification";
import { profile } from "./profile";
import { purchase } from "./purchase";
import { review } from "./review";
import { reviewLp } from "./reviewLp";
import { search } from "./search";
import { settings } from "./settings";
import { signupBonus } from "./signupBonus";
import { validation } from "./validation";

/**
 * アプリ内文言の一元管理。
 * 旧 i18n（locales/ja.json）から移行。補間は関数値で表現する。
 */
export const TEXT = {
  common,
  validation,
  nav,
  landing,
  chat,
  gift,
  myProfile,
  editProfile,
  auth,
  discover,
  messages,
  profile,
  news,
  moderation,
  notification,
  call,
  avatar,
  purchase,
  board,
  review,
  reviewLp,
  lovenseLp,
  search,
  live,
  callError,
  insufficientPointSheet,
  banner,
  signupBonus,
  dailyBonus,
  gallery,
  footprint,
  bookmarkList,
  likeList,
  settings,
  fleamarket,
  contact,
  media,
  launchCampaign,
} as const;
